// extracted by mini-css-extract-plugin
export default {"button":"ThemeToggle_button__SO3ag","icon":"ThemeToggle_icon__3pE7f"};